'use client';

import Link from "next/link";


import { useNavigate } from "../../hooks/useNavigate";
import React from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaXTwitter,
  FaGlobe,
} from "react-icons/fa6";
import { StyledButton } from "../../components/Buttons/StyledButton";
import { GoArrowUpRight } from "react-icons/go";
import Image from "../../components/Image";

const career = "/assets/additional_services/team-work.png";
const branding = "/assets/additional_services/news.png";
const collaboration = "/assets/additional_services/connect.png";
const contact = "/assets/additional_services/block-chain.png";
const socialLinks = [
  {
    href: "https://www.facebook.com/profile.php?id=61571785329732",
    icon: FaFacebook,
    text: "Facebook",
    color: "group-hover/nested:text-[#1877F2]",
  },
  {
    href: "https://x.com/centeratech",
    icon: FaXTwitter,
    text: "Twitter",
    color: "group-hover/nested:text-[#AAB8C2]",
  },
  {
    href: "https://www.instagram.com/centera.tech",
    icon: FaInstagram,
    text: "Instagram",
    customIcon: (
      <svg
        className="w-4 h-4 transition-all duration-500 ease-in-out"
        viewBox="0 0 169 169"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="instagramGradient" x1="1" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#833AB4" />
            <stop offset="50%" stopColor="#C13584" />
            <stop offset="100%" stopColor="#ffbf1f" />
          </linearGradient>
        </defs>

        <g className="transition-all duration-500 ease-in-out">
          <g className="fill-white transition-all duration-500 group-hover/nested:opacity-0">
            <path
              d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
        c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
        c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
        c17.455,0,31.656,14.201,31.656,31.655V122.407z"
            />
            <path
              d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
        C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
        c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
            />
            <path
              d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
        c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
        C135.661,29.421,132.821,28.251,129.921,28.251z"
            />
          </g>

          <g className="fill-[url(#instagramGradient)] transition-all duration-500 opacity-0 group-hover/nested:opacity-100">
            <path
              d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752
        c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407
        c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752
        c17.455,0,31.656,14.201,31.656,31.655V122.407z"
            />
            <path
              d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561
        C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561
        c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z"
            />
            <path
              d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78
        c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78
        C135.661,29.421,132.821,28.251,129.921,28.251z"
            />
          </g>
        </g>
      </svg>
    ),
  },
  {
    href: "https://www.youtube.com/@CenteraTech",
    icon: FaYoutube,
    text: "YouTube",
    color: "group-hover/nested:text-[#FF0000]",
  },
  {
    href: "https://www.linkedin.com/in/centera-tech-72ba35347",
    icon: FaLinkedin,
    text: "LinkedIn",
    color: "group-hover/nested:text-[#0A66C2]",
  },
  {
    href: "https://ranjitpasale.com/",
    icon: FaGlobe,
    text: "CEO - Ranjit Pasale",
    color: "group-hover/nested:text-[--accent-light]",
  },
];

const Section = ({ tag, image, title, content, reverse, list, ...props }) => {
  return (
    <div
      className={`flex flex-col ${
        reverse ? "md:flex-row-reverse" : "md:flex-row"
      } md:items-center gap-3 md:gap-4 mx-4 my-1 py-0 group relative`}
      {...props}
    >
      {/* Secondary Tag for small screens */}
      {/* <div className="flex md:hidden justify-center w-full">
        <SecondaryTag text={tag} />
      </div> */}
      {/* Image */}
      {/* <div className="w-full md:w-[35%] h-40 sm:h-52">
        <img
          src={image}
          alt={tag}
          className="object-cover h-full w-full rounded-lg shadow-lg transition-all duration-500 opacity-80 group-hover:opacity-100 group-hover:scale-105"
        />
      </div> */}
      {/* Content */}
      <div className="w-full relative overflow-hidden px-2 py-4">
        {/* <div className="hidden md:flex justify-center lg:justify-start mb-4">
          <SecondaryTag text={tag} />
        </div> */}
        <h3 className="text-xl">{tag}</h3>
        <h2 className="text-2xl lg:text-3xl font-medium mb-4">{title}</h2>
        {list ? (
          <ul className="space-y-2 text-color-2">
            {list.map((item, idx) => (
              <li key={idx}>
                <span className="text-primary font-bold">•</span> {item}
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-color-2 leading-relaxed">{content}</div>
        )}
        {/* Gradient Decorations */}
        {/* <div
          className={`pointer-events-none absolute -bottom-20 right-10 -rotate-45 w-[300px] h-[300px] bg-[radial-gradient(circle,_var(--accent-2-transparent-1),_var(--secondary-bg),_var(--accent-dark))] blur-3xl opacity-20`}
        ></div>
        <div
          className={`pointer-events-none absolute top-0 left-0 -rotate-45 w-[300px] h-[200px] bg-[radial-gradient(circle,_var(--accent-2-transparent-1),_var(--accent-dark))] blur-3xl opacity-10`}
        ></div> */}
      </div>
    </div>
  );
};

function AboutUs() {
  const navigate = useNavigate();

  const handleButtonClick = (path) => {
    navigate(path);
  };

  const aboutSections = [
    {
      id: "about-us",
      title: "About Us",
      headings:
        "Custom Software Solutions Tailored to Your Unique Business Needs",
      content: (
        <>
          At Centera Tech, we are a software company dedicated to delivering
          innovative solutions tailored to our clients’ needs. Founded in 2025
          by Ranjit Pasale, an experienced private developer, our mission is to
          provide reliable and effective software services for businesses across
          various industries.
        </>
      ),
    },
    {
      id: "our-journey",
      title: "Our Journey",
      headings: "From PHP Developer to Leading Software Innovator",
      content: (
        <>
          Ranjit, the CEO of Centera Tech, began his career as a PHP developer,
          earning recognition for developing a Central Banking System (CBS)
          application from scratch when online banking was still new to the
          world. Over the years, he has led teams of up to 80 professionals,
          successfully completing projects in industries such as fintech,
          education, blockchain, investment, and entertainment.
        </>
      ),
    },
    {
      id: "what-we-do",
      title: "What We Do",
      headings: "Delivering Innovative Software Solutions Across Industries",
      content: (
        <>
          At Centera Tech, we craft tailored software solutions across
          industries:
          <ul className="space-y-2 my-2 text-color-2">
            <li>• Enterprise: ERP, CRM, HRM, and other business tools</li>
            <li>
              • Digital Platforms: Social media, chat apps, podcasts, streaming
            </li>
            <li>
              • Web & Mobile: Portals, booking systems, and event management
            </li>
          </ul>
          Notable projects include HBCU, MaxBet, DOLR Coin, Enum
          Exchange, and Blue Moose TV.
          <div>
            <StyledButton
              text="Explore Our Projects"
              className="my-2"
              onClick={() => handleButtonClick("/projects")}
            />
          </div>
        </>
      ),
    },
    {
      id: "technologies",
      title: "Technologies We Use",
      headings: "Utilizing Cutting-edge Tools for Quality and Scalability",
      content: (
        <>
          We use a wide range of technologies to ensure quality and scalability,
          including:
          <ul className="space-y-2 my-2 text-color-2">
            <li>• Frameworks: CodeIgniter, Laravel</li>
            <li>• Front-End Tools: React JS, React Native, Next JS</li>
          </ul>
          <div>
            <StyledButton
              text="Discover the Stack"
              className="my-2"
              onClick={() => handleButtonClick("/info/tech-stack")}
            />
          </div>
        </>
      ),
    },
    {
      id: "philosophy",
      title: "Our Philosophy",
      headings: "Focusing on Completion with Collaborative Excellence",
      content: (
        <>
          We pride ourselves on finishing what we start. With a collaborative
          approach, we work closely with international clients to shape ideas
          into products that empower businesses and individuals alike.
        </>
      ),
    },
    {
      id: "legacy",
      title: "A Legacy of Expertise",
      headings: "Building Strong Relationships with Meaningful Software",
      content: (
        <>
          We’ve been fortunate to work with visionaries like Dr. Lael Alexander,
          creator of screen sharing technology. Our dedication to providing
          effective solutions has helped us build lasting relationships and
          impactful software.
        </>
      ),
    },
    {
      id: "connect",
      title: "Connect With Us",
      headings: "Let's Build Solutions That Make a Real Difference",
      content: (
        <>
          <div className="flex flex-wrap justify-start gap-4">
            {socialLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className=""
              >
                <div className="flex items-center gap-2.5 py-2 px-2 md:px-4 rounded-lg border-[0.771px] border-color-97 bg-color-99 group/nested transition-all duration-300 cursor-pointer">
                  {link.customIcon || (
                    <link.icon
                      className={`w-4 h-4 text-color-1 transition-all duration-300 
                          ${link.color || ""}
                        `}
                    />
                  )}
                  <div className="text-color-1 text-xs leading-[normal] transition-all duration-300  group-hover/nested:text-[var(--accent-light)]">
                    {link.text}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="mx-auto px-4 sm:px-8 md:px-12 lg:px-16 max-w-7xl">
        {/* Background */}
        <div className="absolute inset-0 pointer-events-none z-30">
          <div className="mt-2 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
          <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" />
          {/* <div className="-mt-40 bg-cover bg-center bg-no-repeat pointer-events-none opacity-100 z-50 bg-[url(/assets/grid-bg.svg)] h-[700px]" /> */}
          <div
            className={`pointer-events-none absolute top-[500px] -left-20 -rotate-45 rounded-full w-[600px] h-[400px]  bdg-red-400 bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-2-transparent-1))] blur-3xl opacity-15`}
          ></div>
          <div
            className={`pointer-events-none absolute top-[300px] -right-20 -rotate-45 rounded-full w-[600px] h-[400px]  bdg-red-400 bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-2-transparent-1))] blur-3xl opacity-15`}
          ></div>
          <div
            className={`pointer-events-none absolute top-[1000px] right-40 -rotate-45 rounded-full w-[600px] h-[400px]  bdg-red-400 bg-[radial-gradient(circle,_var(--accent-dark),_var(--accent-2-transparent-1))] blur-3xl opacity-15`}
          ></div>
        </div>

        <p className="text-color-2 text-3xl md:text-4xl font-medium text-center mt-8 mb-4">
          Discover
          <span className="text-color-1"> Centera&nbsp;Tech</span>
        </p>

        {/* Sections */}
        {aboutSections.map((s, index) => (
          <Section
            key={index}
            tag={s.title}
            image={s.image}
            reverse={index % 2 !== 0}
            title={s.heading}
            content={s.content}
          />
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-5 max-w-screen-2xl mx-auto px-4 md:px-10 2xl:px-16 mt-10">
        {[
          {
            title: "Shape The Future",
            description: "Join our mission and build a career that matters.",
            image: career,
            path: "/careers",
          },
          {
            title: "Master The Brand",
            description: "Discover our visual identity and design philosophy.",
            image: branding,
            path: "/brand-guidelines",
          },
          {
            title: "Unite For Impact",
            description: "Partner with us to create meaningful collaborations.",
            image: collaboration,
            path: "/collaboration",
          },
          {
            title: "Launch Your Vision",
            description: "Kickstart your project with expert-driven solutions.",
            image: contact,
            path: "/contact-us",
          },
        ].map((card) => (
          <Description
            key={card.title}
            title={card.title}
            text={card.description}
            src={card.image}
            link={card.path}
          />
        ))}
      </div>
    </>
  );
}

export default AboutUs;

const Description = ({ title = "Title", text = "Subtitle", src, link }) => (
  <Link
    href={link}
    className={`relative h-full w-full p-px rounded-xl overflow-hidden group transition-opacity duration-500`}
  >
    <div className="absolute inset-0 rounded-xl bg-[linear-gradient(155deg,var(--accent-light),#555_60%)] transition-transform duration-700 group-hover:rotate-180 blur-3xl scale-150"></div>
    <div
      className={`relative h-full flex flex-col flex-shrink-0 items-start justify-center gap-8 p-4 py-3 md:py-6 md:p-8 pb-16 md:pb-16 rounded-xl bg-color-98 `}
    >
      <div
        className={`flex flex-col items-start gap-4 self-stretch transition-all duration-300 z-10 pr-10`}
      >
        <div className="text-color-1 text-2xl lg:text-4xl font-semibold leading-[normal]">
          {title}
        </div>
        <div className="text-color-2 text-ellipsis">{text}</div>
      </div>
      <div className="absolute bottom-5 right-5 z-10">
        <div
          aria-label={`Checkout ${title}`}
          className="scale-90 h-12 w-12 rounded-full flex justify-center items-center overflow-hidden cursor-pointer relative transition-all duration-500 group/nested hover:opacity-50 border"
        >
          <span className="sr-only">{title}</span>
          <div className="absolute inset-0 bg-[linear-gradient(180deg,_#fff,_#fff)] opacity-100 group-hover:opacity-0 transition-opacity duration-500"></div>
          <div className=" w-2 h-2 absolute -left-1 -bottom-1 group-hover:left-12 group-hover:bottom-9 -translate-x-1/2 translate-y-1/2 bg-color-100 group-hover:bg-color-1 rounded-full transition-all duration-700"></div>
          <GoArrowUpRight className="relative z-10 transition-all duration-500 text-color-100 group-hover:text-color-1 text-2xl group-hover:text-3xl font-bold " />
        </div>
      </div>
      <div className="absolute inset-0 object-cover h-full opacity-20 group-hover:opacity-10 group-hover:scale-125 origin-top-left transition-all duration-700 group-hover:blur-md">
        <Image src={src} alt={title} className="h-full" />
      </div>
      <div className="absolute inset-0 bg-[linear-gradient(-45deg,#0000,#000a,#0000)] rounded-xl"></div>
      <div className="absolute top-0 -right-20 -rotate-45 w-[300px] h-[100px] bg-[radial-gradient(circle,_var(--accent-light),_var(--accent-light))] blur-3xl opacity-10 z-10"></div>
    </div>
  </Link>
);
